import React, { useEffect } from 'react'

import getLoginUser from 'core/application/account/loginUser'
import { ProductIds } from 'core/application/commons/config'

import useLoginUser from 'common/hooks/useLoginUser'
import useQueryRequest from 'common/hooks/useQueryRequest'

import { Skeleton } from 'common/components'

import GroupHraEligibleEmployeeSignup from './groupHra/eligibleEmployee'
import IchraEligibleEmployeeSignup from './ichra/eligibleEmployee'
import PerksEligibleEmployeeSignup from './perks/eligibleEmployee'
import QseHraEligibleEmployeeSignup from './qseHra/eligibleEmployee'

const EligibleEmployeeSignup: React.FC = () => {
  const [user] = useQueryRequest(null, () => getLoginUser())
  const [loginUser, setLoginUser] = useLoginUser()

  const eeSignUp = new Map<number, any>()
  eeSignUp.set(ProductIds.GroupHraId, <GroupHraEligibleEmployeeSignup />)
  eeSignUp.set(ProductIds.Perks, <PerksEligibleEmployeeSignup />)
  eeSignUp.set(ProductIds.QsehraId, <QseHraEligibleEmployeeSignup />)
  eeSignUp.set(ProductIds.IchraId, <IchraEligibleEmployeeSignup />)

  useEffect(() => {
    if (user) {
      setLoginUser(user)
    }
  }, [user])

  return (
    <Skeleton active={true} loading={!loginUser}>
      {loginUser && eeSignUp.get(loginUser.productId)}
    </Skeleton>
  )
}

export default EligibleEmployeeSignup
